function initFooterAccordion() {
  const isMobile = window.innerWidth <= 767;

  document.querySelectorAll('.footer__block--links').forEach(function (block) {
    const heading = block.querySelector('.h6');
    const content = block.querySelector('ul');

    if (!heading || !content) return;

    // Prevent duplicate event listeners
    if (!heading.dataset.accordionBound) {
      heading.dataset.accordionBound = "true";

      heading.addEventListener('click', function () {
        if (window.innerWidth > 767) return;

        const isActive = block.classList.contains('active');

        document.querySelectorAll('.footer__block--links').forEach(function (item) {
          item.classList.remove('active');
          const list = item.querySelector('ul');
          if (list) list.style.display = 'none';
        });

        if (!isActive) {
          block.classList.add('active');
          content.style.display = 'block';
        }
      });
    }

    // Set initial state based on screen size
    if (isMobile) {
      if (!block.classList.contains('active')) {
        content.style.display = 'none';
      }
    } else {
      block.classList.remove('active');
      content.style.display = '';
    }
  });
}

document.addEventListener('DOMContentLoaded', initFooterAccordion);
window.addEventListener('resize', initFooterAccordion);

// document.addEventListener('click', function (event) { 
//   const trigger = event.target.closest('[fdd-modal-trigger]');
//   if (trigger) {
//     event.preventDefault();
//     console.log('trigger');
//     const fddDate = trigger.getAttribute('data-fdd-date');

//     const modal = document.querySelector('.pdp-fdd-modal');
//     const modalsetDate = modal.querySelector('.Special-date');
//     if (modal) {
//       modalsetDate.textContent = fddDate || '';
//       modal.classList.add('open');
//     }
//     return;
//   }

//   // Confirm button inside FDD modal
//   const confirmButton = event.target.closest('.SpecialAgree');
//   if (confirmButton) {
//     event.preventDefault();
//     const modal = document.querySelector('.pdp-fdd-modal');
//     if (modal) {
//       modal.classList.remove('open');
//     }
//     const pdp_atc_submit_btn = document.querySelector('.product-info product-form buy-buttons button[type="submit"]');
//      if (pdp_atc_submit_btn) {
//       const form = pdp_atc_submit_btn.closest('form');
//       if (form) {
//         form.requestSubmit(pdp_atc_submit_btn);
//       }
//     }
//   }

//     // Close button inside FDD modal
//   const closeButton = event.target.closest('.SpecialClose');

//   if (closeButton) {
//     event.preventDefault();
//     const modal = document.querySelector('.pdp-fdd-modal');
//     if (modal) {
//       modal.classList.remove('open');
//     }
//     return;
//   }
// });

// =========================================
// let fddQuickView = null;
// let fddProtectQuickView = false;
// document.addEventListener('click', function (event) {
//   const trigger = event.target.closest('[fdd-modal-trigger]');

//   if (trigger) {
//     console.debug('fdd_modal trigger');
//     event.preventDefault();

//     const fddDate = trigger.getAttribute('data-fdd-date');
//     const maxQtyfdd = trigger.getAttribute('data-fdd-qty');
//     const variantId = String(trigger.getAttribute('data-fdd-variant-id') || '');
//     const modal = document.querySelector('.pdp-fdd-modal');

//     console.debug('Current variant ID:', variantId);

//     // Find the current product/quick-view parent
//     const productParent = trigger.closest('.shopify-section--main-product, quick-buy-modal');
//     console.debug('productParent:', productParent);

//     // Find the same variant in cart
//     const cartItem = Array.from(
//       document.querySelectorAll(
//         'cart-drawer line-item quantity-input.quantity-selector__input-wrapper[data-line-item-id]'
//       )
//     ).find((item) => {
//       return String(item.getAttribute('data-line-item-id')) === variantId;
//     });

//     // Quantity of this variant already in cart
//     const cartQty = cartItem
//       ? Number(cartItem.querySelector('input')?.value || 0)
//       : 0;

//     // Get quantity from current product parent
//     const quantityInput = productParent
//       ? productParent.querySelector('input[name="quantity"]')
//       : null;

//     const selectedQty = quantityInput
//       ? Number(quantityInput.value || 1)
//       : 1;

//     // If this variant is already in cart and max quantity has been reached, do not open the modal.
//     const maxQtyMessages = productParent.querySelectorAll('.fdd-max-qty-message');
//     if (maxQtyfdd > 0 && cartQty >= maxQtyfdd) {
//       console.debug('Maximum quantity already reached');
//       maxQtyMessages.forEach((maxQtyMessage) => {
//         maxQtyMessage.textContent =
//           `You've reached the maximum of ${maxQtyfdd} for this item.`;
//         maxQtyMessage.hidden = false;
//       });

//       setTimeout(() => {
//         maxQtyMessages.forEach((maxQtyMessage) => {
//           maxQtyMessage.hidden = true;
//           maxQtyMessage.textContent = '';
//         });
//       }, 3000);
//       return;
//     }

//     // Calculate remaining quantity
//     const remainingQty = maxQtyfdd > 0
//       ? Math.max(0, maxQtyfdd - cartQty)
//       : selectedQty;

//     // If no quantity is remaining, don't open modal.
//     if (remainingQty <= 0) {
//       console.debug('No remaining quantity available');
//       return;
//     }

//     // Never allow quantity greater than remaining quantity.
//     const finalQty = Math.min(selectedQty, remainingQty);

//     // Update only the current product/quick-view quantity
//     if (quantityInput) {
//       quantityInput.value = finalQty;

//       quantityInput.dispatchEvent(
//         new Event('change', {
//           bubbles: true
//         })
//       );
//     }

//     // Store current parent for Agree button
//     if (modal) {
//       modal._fddProductParent = productParent;
//       const modalsetDate = modal.querySelector('.Special-date');

//       if (modalsetDate) {
//         modalsetDate.textContent = fddDate || '';
//       }
//       modal.classList.add('open');
//     }

//     fddQuickView = trigger.closest('quick-buy-modal[open]');
//     if (fddQuickView && !fddQuickView._fddHidePatched) {
//       const originalHide = fddQuickView.hide;

//       fddQuickView.hide = function () {
//         if (fddProtectQuickView) {
//           return;
//         }

//         return originalHide.apply(this, arguments);
//       };

//       fddQuickView._fddHidePatched = true;
//     }

//   }

//   // Confirm/Agree button inside FDD modal
//   const confirmButton = event.target.closest('.SpecialAgree');

//   if (confirmButton) {
//     event.preventDefault();

//     const modal = document.querySelector('.pdp-fdd-modal');

//     if (modal) {
//       modal.classList.remove('open');
//     }

//     // Get the exact product/quick-view parent which opened the modal
//     const productParent = modal?._fddProductParent;

//     if (!productParent) {
//       console.debug('FDD product parent not found');
//       return;
//     }

//     // Find ATC button ONLY inside current parent
//     const atcSubmitButton = productParent.querySelector(
//       'product-form buy-buttons button[type="submit"]'
//     );

//     if (!atcSubmitButton) {
//       console.debug('ATC button not found');
//       return;
//     }

//     const form = atcSubmitButton.closest('form');
//     if (!form) {
//       console.debug('ATC form not found');
//       return;
//     }

//     // Submit only the current product / quick-view form
//     form.requestSubmit(atcSubmitButton);

//     return;
//   }

//   // Close button inside FDD modal
//   const closeButton = event.target.closest('.SpecialClose, .pdp-fdd-modal .overlay');
//   const modal = document.querySelector('.pdp-fdd-modal');

//   if (closeButton) {
//     console.log('SpecialClose');
//     console.debug('SpecialClose');
//     event.preventDefault();
//     if (modal) {
//       modal.classList.remove('open');
//       modal._fddProductParent = null;
//     }

//     return;
//   }

// });

// document.addEventListener('click', function (event) {
//   const specialModal = document.querySelector('#SpecialOrder.open');
//   if (!specialModal) return;
//   const contentBox = event.target.closest('#SpecialOrder .pdp-fdd-modal-inner');
//   if (!contentBox) return;

//   // Close / Agree / other buttons ko normal behavior do
//   if (event.target.closest('button.SpecialAgree')) {
//     return;
//   }

//   // Sirf text/content click ke liye Quick View ko protect karo
//   fddProtectQuickView = true;

//   // Current click complete hone ke baad flag reset
//   setTimeout(() => {
//     fddProtectQuickView = false;
//   }, 0);
// }, true);
// ==========================================

let fddQuickView = null;
let fddProtectQuickView = false;

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[fdd-modal-trigger]');
  if (trigger) {
    console.debug('fdd_modal trigger');
    console.log('fdd_modal trigger');
    event.preventDefault();

    const fddDate = trigger.getAttribute('data-fdd-date');
    const modal = document.querySelector('.pdp-fdd-modal');
    const productParent = trigger.closest('.shopify-section--main-product, quick-buy-modal');

    console.debug('productParent:', productParent);
    console.log('productParent:', productParent);

    if (modal) {
      modal._fddProductParent = productParent;
      const modalsetDate = modal.querySelector('.Special-date');

      if (modalsetDate) {
        modalsetDate.textContent = fddDate || '';
      }

      modal.classList.add('open');
    }

    fddQuickView = trigger.closest('quick-buy-modal[open]');

    if (fddQuickView && !fddQuickView._fddHidePatched) {
      const originalHide = fddQuickView.hide;
      fddQuickView.hide = function () {
        if (fddProtectQuickView) {
          return;
        }
        return originalHide.apply(this, arguments);
      };
      fddQuickView._fddHidePatched = true;
    }
  }

  const confirmButton = event.target.closest('.SpecialAgree');
  if (confirmButton) {
    event.preventDefault();

    const modal = document.querySelector('.pdp-fdd-modal');

    if (modal) {
      modal.classList.remove('open');
    }

    // Get the exact product/quick-view parent
    // which opened the modal
    const productParent = modal?._fddProductParent;

    console.debug('FDD product parent:', productParent);
     console.log('FDD product parent:', productParent);

    if (!productParent) {
      console.debug('FDD product parent not found');
      return;
    }


    // ==========================================
    // Find ATC button ONLY inside current parent
    // ==========================================

    const atcSubmitButton = productParent.querySelector(
      'product-form buy-buttons button[type="submit"]'
    );

    console.debug('ATC button:', atcSubmitButton);

    if (!atcSubmitButton) {
      console.debug('ATC button not found');
      return;
    }

    const form = atcSubmitButton.closest('form');
    if (!form) {
      console.debug('ATC form not found');
      return;
    }

    // Submit only the current product / quick-view form
    form.requestSubmit(atcSubmitButton);
    return;
  }

  const closeButton = event.target.closest('.SpecialClose, .pdp-fdd-modal .overlay');
  if (closeButton) {
    event.preventDefault();
    const modal = document.querySelector('.pdp-fdd-modal');
    if (modal) {
      modal.classList.remove('open');
      modal._fddProductParent = null;
    }
    return;
  }

});


document.addEventListener('click', function (event) {
  const specialModal = document.querySelector('#SpecialOrder.open');
  if (!specialModal) return;
  const contentBox = event.target.closest('#SpecialOrder .pdp-fdd-modal-inner');
  if (!contentBox) return;

  // Close / Agree / other buttons ko normal behavior do
  if (event.target.closest('button.SpecialAgree')) {
    return;
  }

  // Sirf text/content click ke liye Quick View ko protect karo
  fddProtectQuickView = true;

  // Current click complete hone ke baad flag reset
  setTimeout(() => {
    fddProtectQuickView = false;
  }, 0);
}, true);
